import { render, staticRenderFns } from "./GlobalTimer.vue?vue&type=template&id=3b94ed50&"
import script from "./GlobalTimer.vue?vue&type=script&lang=js&"
export * from "./GlobalTimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports